import store from "@/state/store";

const PAS_APPLICATION = "payment-application";
const PAS_DASHBOARD_PERMISSION = "pas.dashboard.dashboard.view";

/**
 * Where a logged-in user starts: the PAS dashboard when the active service is PAS and they may
 * view it, the home page otherwise. "Active service" matches the menu: the selected application,
 * or the first accessible one when none is selected yet.
 */
export function landingPath() {
  const { currentApplication, tenantApplications } = store.state.auth;
  const firstAccessible = (tenantApplications || []).find((app) => app.accessible);
  const activeApplication = currentApplication || firstAccessible?.code;

  const canViewPasDashboard =
    activeApplication === PAS_APPLICATION && store.getters["auth/hasPermission"](PAS_DASHBOARD_PERMISSION);

  return canViewPasDashboard ? "/payment/dashboard" : "/home";
}
